
import React, { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import ResolveIssuesTable from './resolveIssuesTable';

class ResolveIssues extends Component {
    state = {
        componentSteps: [
            {
                title: 'Get Request Issues',
                content: <GetInfo moveStepByRequestID param request />,
                id: 0,
            }, {
                title: 'Resolve Issues',
                content: <ResolveIssuesTable />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default ResolveIssues
